import { initializePatientSubscription } from './patient_subscription';
import { initializeAppointmentsSubscription } from './appointments_subscription';
import { initializeBillSubscription } from './bill_subscription';
import { initializeDashboardSubscription } from './dashboard_subscription';
import { initializeDispensationSubscription } from './dispensation_subscription';
import { initializeInventorySubscription } from './inventory_subscription';
import { initializeLabTestSubscription } from './lab_test_subscription';
import { initializeUserSubscription } from './user_subscription';
import { initializePrescriptionQueueSubscription } from './prescription_queue_subscription';
import { initializePatientQueueSubscription } from './patient_queue_update_subscription';
import { initializeLabRequestSubscription } from './initializeLabRequestSubscription';
import { initializeAuditSubscription } from './audit_event';
import { initializeLabSupplySubscription } from './lab_supply_subscription';

export const initializeAllSubscriptions = () => {
  initializePatientSubscription();
  initializeAppointmentsSubscription();
  initializeBillSubscription();
  initializeDashboardSubscription();
  initializeDispensationSubscription();
  initializeInventorySubscription();
  initializeLabTestSubscription();
  initializeUserSubscription();
  initializePrescriptionQueueSubscription();
  initializePatientQueueSubscription();
  initializeLabRequestSubscription();
  initializeLabSupplySubscription();
  initializeAuditSubscription();
};
